/***格式化日期 */
function checkName(rule, value, callback) {
    // 验证名字是否合法
    if (value) {
        var value_ = value.trim().replace(/\s/g, '');
        var len = value_.length;
        if (len > 15) {
            return callback(new Error('姓名最长15个汉字'));
        }
        else {
            callback();
        }
    }
    else {
        callback();
    }
}
function checkInteger(rule, value, callback) {
    // 验证是否为小于100的整数
    var res = /^\s*[1-9][0-9]{0,1}\s*$/;
    if (!res.test(value)) {
        return callback(new Error('请输入小于100的正整数'));
    }
    else {
        callback();
    }
}
// 验证是否为某个范围的整数
function isInteger(rule, value, callback) {
    // TODO:需要改成通用模块
    // 验证范围整数
    var res = /^\s*[1-9][0-9]{0,1}\s*$/;
    var range = rule.range;
    if (value === '') {
        return callback(new Error('请输入数字'));
    }
    if (!res.test(value)) {
        return callback(new Error('请输入1-31之间的正整数'));
    }
    if (value > 31) {
        return callback(new Error('请输入1-31之间的正整数'));
    }
    else {
        callback();
    }
}
function checkNum(rule, value, callback) {
    var reg = /^[0-9]{0,6}(\.[0-9]{1,2})?$/;
    if (value == 0) {
        return callback(new Error('请输入大于0的数字'));
    }
    if (!reg.test(value)) {
        return callback(new Error('整数最多6位，小数最多2位'));
    }
    else {
        callback();
    }
}
export { checkName, checkInteger, checkNum, isInteger };
